import { motion } from "framer-motion";
import { MapPin, ArrowDown } from "lucide-react";
import { BUSINESS } from "../data/products";

const HERO_BG =
  "https://customer-assets-agu9un31.emergentagent.net/job_b691172f-bb5a-4c7d-82b8-24fe2538ea1e/artifacts/3udalmdc_Image%209-17-26%20at%2011.15%E2%80%AFAM.jpeg";

export const Hero = () => {
  const scrollTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-screen flex items-end justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt="Premium smoke and vape shop interior in Morrisville PA"
          className="w-full h-full object-cover brightness-110 blur-[3px] scale-105"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0b]/40 via-[#0a0a0b]/25 to-[#0a0a0b]" />
        <div className="absolute inset-0 grain opacity-[0.07] mix-blend-overlay pointer-events-none" />
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center pb-28">
        <motion.span
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-block text-xs md:text-sm uppercase tracking-[0.3em] text-[#39ff14] mb-6"
          data-testid="hero-eyebrow"
        >
          Vape Shop • Smoke Shop • Morrisville, PA
        </motion.span>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="mt-7 text-base md:text-lg text-zinc-300 max-w-2xl mx-auto leading-relaxed"
        >
          Smok City is your ultimate vape shop and smoke store in Morrisville. From
          disposable vapes and tobacco to smoking accessories, kratom, and THCA—we carry
          the top brands and innovative devices like the Solaris 25000 and Flair Ultra,
          all in one stop.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.4 }}
          className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
        >
          <a
            data-testid="hero-directions-button"
            href={BUSINESS.mapsLink}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#00e5ff] text-black font-semibold hover:shadow-[0_0_32px_rgba(0,229,255,0.55)] transition-all duration-300 hover:-translate-y-1 w-full sm:w-auto justify-center"
          >
            <MapPin size={18} /> Get Directions
          </a>
          <button
            data-testid="hero-browse-button"
            onClick={() => scrollTo("products")}
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full glass text-white font-medium hover:border-white/30 hover:bg-white/10 transition-all duration-300 hover:-translate-y-1 w-full sm:w-auto justify-center"
          >
            Browse Products
          </button>
        </motion.div>
      </div>

      <motion.button
        onClick={() => scrollTo("products")}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 text-zinc-400 hover:text-white"
        style={{ animation: "float-glow 2.5s ease-in-out infinite" }}
        aria-label="Scroll down"
        data-testid="hero-scroll-indicator"
      >
        <ArrowDown size={22} />
      </motion.button>
    </section>
  );
};
